<template>
  <main>
    <tab-header-customer-id />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <!-- 資料呈現區塊 -->
          <div class="row">
            <div class="col-12">
              <!-- Search Block-->
              <table id="searchBlock">
                <thead>
                  <tr>
                    <th style="width:203px">
                      <select
                        :id="`param-type`"
                        :data-vv-name="`param-type`"
                        v-validate="'required'"
                        data-vv-as="查詢條件"
                        data-vv-scope="IDs"
                        class="form-control select-width"
                        v-model="selectKey"
                        :class="{ 'is-invalid': errors.has('IDs.param-type') }"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(key, value, index) in selectOption"
                          :key="`param-type-${index}`"
                          :value="value"
                        >
                          {{ key }}
                        </option>
                      </select>
                    </th>
                    <td>
                      <input
                        type="text"
                        :id="`search-param`"
                        :data-vv-name="`search-param`"
                        v-validate="'required'"
                        data-vv-as="查詢條件"
                        data-vv-scope="IDs"
                        placeholder="請輸入查詢內容"
                        class="form-control"
                        v-model="selectVal"
                        alt="ch"
                        :class="{
                          'is-invalid': errors.has('IDs.search-param'),
                        }"
                      />
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery('val')"
                        >查詢</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <th style="width:203px">異動日期</th>
                    <td class="text-center">
                      <select
                        :id="`start-date-year`"
                        :data-vv-name="`start-date-year`"
                        v-validate="'required'"
                        data-vv-as="異動日期(起)"
                        data-vv-scope="Dates"
                        class="form-control form-control-inline"
                        v-model="start_date[0]"
                        :class="{
                          'is-invalid': errors.has('Dates.start-date-year'),
                        }"
                      >
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`start-year-${y_opt_i}`"
                          :value="opt"
                        >
                          {{ opt - 1911 }}年
                        </option>
                      </select>
                      <span class="text">/</span>
                      <select
                        :id="`start-date-month`"
                        :data-vv-name="`start-date-month`"
                        v-validate="'required'"
                        data-vv-as="異動日期(起)"
                        data-vv-scope="Dates"
                        class="form-control form-control-inline mr-2"
                        v-model="start_date[1]"
                        :class="{
                          'is-invalid': errors.has('Dates.start-date-month'),
                        }"
                      >
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`start-month-${m_opt_i}`"
                          :value="opt"
                        >
                          {{ opt }}月
                        </option>
                      </select>

                      <span class="mr-2">~</span>

                      <select
                        :id="`end-date-year`"
                        :data-vv-name="`end-date-year`"
                        v-validate="'required'"
                        data-vv-as="異動日期(訖)"
                        data-vv-scope="Dates"
                        class="form-control form-control-inline"
                        v-model="end_date[0]"
                        :class="{
                          'is-invalid': errors.has('Dates.end-date-year'),
                        }"
                      >
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`end-year-${y_opt_i}`"
                          :value="opt"
                        >
                          {{ opt - 1911 }}年
                        </option>
                      </select>
                      <span class="text">/</span>
                      <select
                        :id="`end-date-month`"
                        :data-vv-name="`end-date-month`"
                        v-validate="'required'"
                        data-vv-as="異動日期(訖)"
                        data-vv-scope="Dates"
                        class="form-control form-control-inline mr-1"
                        v-model="end_date[1]"
                        :class="{
                          'is-invalid': errors.has('Dates.end-date-month'),
                        }"
                      >
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`end-month-${m_opt_i}`"
                          :value="opt"
                        >
                          {{ opt }}月
                        </option>
                      </select>
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery()">查詢</a>
                    </td>
                  </tr>
                </thead>
              </table>
              <br />
              <!-- 資料呈現區塊 -->
              <table
                id="bullentin_datatable"
                class="table datatable table-striped area-list-datatable"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th
                      id="col_FORM_NO"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'form_no'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('form_no')"
                      class="text-center"
                    >
                      簡覆表編號
                    </th>
                    <th
                      id="col_ID"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'id'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('id')"
                      class="text-center"
                    >
                      客戶ID
                    </th>
                    <th
                      id="col_AGNT_ID"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'agnt_id'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('agnt_id')"
                      class="text-center"
                    >
                      業務員ID
                    </th>
                    <th
                      id="col_POLICY_NO"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'policy_no'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('policy_no')"
                      class="text-center"
                    >
                      保單號碼
                    </th>
                    <th
                      id="col_UPD_KIND"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'upd_kind'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('upd_kind')"
                      class="text-center"
                    >
                      異動項目
                    </th>
                    <th
                      id="col_BEF_DATA"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'bef_data'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('bef_data')"
                      class="text-center"
                    >
                      原內容
                    </th>
                    <th
                      id="col_AFT_DATA"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'aft_data'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('aft_data')"
                      class="text-center"
                    >
                      異動內容
                    </th>
                    <th
                      id="col_UPD_TIME"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'upd_time'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('upd_time')"
                      class="text-center"
                    >
                      異動日期
                    </th>
                    <th
                      id="col_EMP_NAME"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'emp_name'
                          ? order.asc
                            ? 'sorting_asc'
                            : 'sorting_desc'
                          : '')
                      "
                      @click="processList('emp_name')"
                      class="text-center"
                    >
                      設定人員
                    </th>
                  </tr>
                </thead>
                <tbody id="phone-edit-view" v-if="rtnList.length > 0">
                  <tr
                    v-for="(item, index) in rtnList"
                    :key="`td-rtnList-${index}`"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.form_no }}</td>
                    <td class="text-center">
                      <Tooltip
                          :position="index < 3 ? 'bottom' : 'top'"
                          expand_col1="客戶ID"
                          :expand_col1_value="item.id"
                          expand_col2="業務員ID"
                          :expand_col2_value="item.agnt_id"
                          expand_col3="原內容"
                          :expand_col3_value="item.bef_data"
                          expand_col4="異動內容"
                          :expand_col4_value="item.aft_data" 
                          expand_col5="設定人員"
                          :expand_col5_value="item.emp_name"                    
                      >
                        {{ item.id | getMaskID}}
                      </Tooltip>
                    </td>
                    <template v-if="item.agnt_id === ''">
                      <td class="text-center">-</td>
                    </template>
                    <template v-else>
                      <td class="text-center">{{ item.agnt_id  | getMaskID}}</td>
                    </template>
                    <template v-if="item.policy_no === ''">
                      <td class="text-center">-</td>
                    </template>
                    <template v-else>
                      <td class="text-center">{{ item.policy_no }}</td>
                    </template>
                    <td>{{ transferUpdKind(item.upd_kind) }}</td>
                    <td>{{ item.bef_data  | getMaskMobile}}</td>
                    <td>{{ item.aft_data  | getMaskMobile}}</td>
                    <td class="text-center">
                      <div class="date">{{ item.upd_time | dateFormat }}</div>
                    </td>
                    <td class="text-center">{{ item.emp_name | getMaskName}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="empty">
                      <h3 class="text-center py-5">無任何資料</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";

//component
import TabHeaderCustomerId from "@/desktop/components/backend/TabHeaderCustomerId";
import mxMask from "@/desktop/components/mxMask";
import Tooltip from "@/desktop/components/ToolTip";
//service
import { queryEditRecord } from "@/service";

export default {
  name: "CustTelEditView",
  mixins: [commonMixin],
  components: {
    TabHeaderCustomerId,
    mxMask,
    Tooltip
  },
  data() {
    return {
      mxMaskOpen: false,
      start_date: [this.moment().year(), this.moment().month() + 1],
      end_date: [this.moment().year(), this.moment().month() + 1],
      yearOpt: [],
      selectOption: {
        form_no: "簡覆表編號",
        id: "客戶ID",
        policy_no: "保單號碼",
        emp_name: "設定人員",
      },
      selectKey: "",
      selectVal: "",
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      rtnList: [], //顯示資料
      order: {
        fieldName: "subject",
        asc: true,
      },
      modalOpen: false,
    };
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "upd_time":
          setTimeout(() => {
            this.rtnList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.rtnList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function (a, b) {
        const ar = a[property] ? a[property] : "";
        const br = b[property] ? b[property] : "";
        let result = ar < br ? -1 : ar > br ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function (a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢
    doQuery(selectKey) {
      let scope;
      if (selectKey) {
        if (selectKey != "val") {
          this.selectKey = selectKey;
        }
        scope = "IDs";
        this.errors.clear("Dates");
      } else {
        scope = "Dates";
        this.errors.clear("IDs");
      }
      this.rtnList = [];
      this.$validator.validateAll(scope).then((el) => {
        if (!el) {
          let errMsg = [];
          this.errors.items.forEach((x) => errMsg.push(x.msg));
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }

        let reqData = {};
        if (!selectKey) {
          let startDate = ""; //查詢的起始日
          let endDate = ""; //查詢的結束日
          let lastDay = ""; //每月最後一天

          let startMonth =
            this.start_date[1].toString().length == 1
              ? "0" + this.start_date[1].toString()
              : this.start_date[1].toString();
          let endMonth =
            this.end_date[1].toString().length == 1
              ? "0" + this.end_date[1].toString()
              : this.end_date[1].toString();

          let start = this.start_date[0] + startMonth;
          let end = this.end_date[0] + endMonth;
          if (parseInt(start) > parseInt(end)) {
            this.setToastMsg("異動日期起始日不可大於結束日");
            return;
          }
          lastDay = new Date(
            this.end_date[0],
            parseInt(this.end_date[1]),
            0
          ).getDate();
          startDate = `${this.start_date[0]}-${startMonth}-01`;
          endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;

          reqData = {
            start_month: startDate,
            end_month: endDate,
          };
        } else {
          reqData[this.selectKey] = this.selectVal;
        }
        this.$validator.reset();
        this.mxMaskOpen = true;

        queryEditRecord(reqData).then((result) => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.rtnList = result.body.result;
            this.registerHanlink(); // 難字顯示
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    },
    //異動項目轉換
    transferUpdKind(updKind) {
      switch (updKind) {
        case "MOB":
          return "手機號碼";
        case "HOME_TEL":
          return "住家電話";
        case "CORP_TEL":
          return "公司電話";
        default:
          return "";
      }
    },
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
